import { Component, OnInit } from '@angular/core';
import { Account } from '../data/account';
import { BaseComponent } from '../base/base.component';
import { ParentAccount } from '../data/parent-account';

@Component({
  selector: 'app-parent-account-detail',
  templateUrl: './parent-account-detail.component.html',
  styleUrls: ['./parent-account-detail.component.css']
})
export class ParentAccountDetailComponent extends BaseComponent implements OnInit {

  parent: ParentAccount;
  studentId: number;
  parentId: number;
  account: Account;

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.parentId = params.parentId;
      this.getStudents();
      this.getAccount();
    });
  }

  getAccount(): void {
    this.dataService.getAccount(this.parentId).subscribe(account => {
      this.account = account;
    });
  }

  getStudents(): void {
    this.dataService.getStudentsByParent(this.parentId)
      .subscribe(parent => {
        this.parent = parent;
      });
  }

  updateAccount() {
    this.startSaveObj(event);
    this.dataService.updateAccount(this.account).subscribe(tmpAccount => {
      if (tmpAccount) {
        this.account.Password = '';
        this.handleSaveSuccess();
        this.getStudents();
      } else {
        this.handleSaveError();
      }
    });
  }
}
